var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"mainFooter"}},[_c('div',{staticClass:"wrapper"},[_c('small',[_vm._v("2019 Copyright - Todos os direitos reservados.")])])])}]

export { render, staticRenderFns }